module.exports = __webpack_public_path__ + "img/Frame 1118four2.4618a3a5.png";